import {
  BellAlertIcon,
  ChartBarSquareIcon,
  DocumentTextIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";
import React from "react";

const AppDesktopNav = ({
  selectedItem,
}: {
  selectedItem: "dashboard" | "transactions" | "metrics" | "alerts";
}) => {
  const selectedItemKlass = "text-gray-100 bg-primary-800";
  return null;
};

export default AppDesktopNav;
